import React from "react";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../../../API/exercise";
import StuAnswerSub from "../../../Question/components/StuAnswerSub";

interface GapFillingProps {
    index?: number;
    data: TopicsItem;
    stuDoFlg: string;
}

export default function PageGapFillingDetail({
    data,
    index,
    stuDoFlg
}: GapFillingProps) {
    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（填空题，{data.score}分）</span>
            </div>
            <div className={style.title}>
                <span
                    className={style.spanHtml}
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>

            <StuAnswerSub stuDoFlg={stuDoFlg} data={data} />
        </div>
    );
}
